import {
  AnalysisType,
  KitTypes,
  SortDirection,
} from '@app/modules/@core/core.types';

export const LABORATORYS_NAME_CONSTANTS = {
  Zagreb: 'Zagreb',
  HongKong: 'Hong Kong',
  Cologne: 'Cologne',
  Belgrade: 'Belgrade',
  Genoma: 'Genoma',
  Medicover: 'Medicover',
  Copenhagen: 'Copenhagen',
  LGCHoddesdon: 'LGC Hoddesdon',
  Budapest: 'Budapest',
  LifeGenomics: 'LifeGenomics',
  Grail: 'Grail',
  HongKongFGI: 'Hong Kong FGI',
  Neodiagnostica: 'Neodiagnostica',
};

export const KIT_LABORATIRIES_LIST = [
  'Zagreb',
  'Hong Kong',
  'Cologne',
  'Belgrade',
  'Genoma',
  'Medicover',
  'Copenhagen',
  'LGC Hoddesdon',
  'Budapest',
  'LifeGenomics',
  'Grail',
  'Hong Kong FGI',
  'Neodiagnostica',
];

export enum Laboratory {
  Zagreb = 'Zagreb',
  HongKong = 'Hong Kong',
  Cologne = 'Cologne',
  Belgrade = 'Belgrade',
  Genoma = 'Genoma',
  Medicover = 'Medicover',
  Copenhagen = 'Copenhagen',
  LGCHoddesdon = 'LGC Hoddesdon',
  Budapest = 'Budapest',
  LifeGenomics = 'LifeGenomics',
  Grail = 'Grail',
  HongKongFGI = 'Hong Kong FGI',
  Neodiagnostica = 'Neodiagnostica',
}

export const STATUSES = {
  generated: 'Generated',
  shipped: 'Shipped',
  claimed: 'Claimed',
  returned: 'Returned',
  sentToLaboratory: 'SentToLaboratory',
  canceled: 'Canceled',
  deprovisioned: 'Deprovisioned',
  failed: 'Failed',
  locked: 'Locked',
};

export const KITS_QUERY_CONSTANTS = {
  Free: 'Free',
  True: 'True',
  False: 'False',
};

export const KITS_PAGE_SORT_SETTINGS = {
  sortDirection: SortDirection.desc,
  orderBy: 'id',
};

// Kit types that are not tracked as a separate partner stock
// (e.g. NIPPT AF is shipped together with NIPPT M)
export const PARTNER_STOCK_HIDDEN_KIT_TYPES: string[] = [
  KitTypes.PremiumPro,
  KitTypes.NipptAf,
  KitTypes.Paternity2,
];

// NEG Single Carrier analyses use only NIPT NEG and EDTA NEG kits. EDTA NEG is
// limited to them, NIPT NEG is also a general kit for other analyses.
export const NEG_SINGLE_CARRIER_ANALYSES: AnalysisType[] = [
  AnalysisType.CF,
  AnalysisType.SMA,
  AnalysisType.FRAGILEX,
];
